import React, { useState } from 'react';
import styled, { cx, StylesProps } from '../../../lib/styles';
import theme, { Brand } from '../../../lib/theme';
import Button from '../Button';

import membershipChallengeStyles from './MembershipChallenge_styles';
import { isEmail } from '../../../lib/validationUtils';
import api from '../../authenticate/Authenticate/api';
import { Pixel } from '../Pixel';
import Icon from '../Icon';
import clsx from 'clsx';

export interface MembershipChallengeProps {
	brand?: Brand;
  title?: string;
  subtitle?: string;
	buttonLabel?: string;
	onClick?: (event: any) => any;
	classes?: string;
}

export const MembershipChallenge = ({
	brand = 'sas',
	title = "Want to read more stories like these?",
	subtitle = `Join our mailing list to receive the latest news, competitions, games, jokes and travel ideas.`,
	buttonLabel = "Sign-up",
	classes,
	onClick,
	styles,
}: MembershipChallengeProps & StylesProps<typeof membershipChallengeStyles>) => {

	const [userEmail, setUserEmail] = useState('');
	const [formTitle, setFormTitle] = useState(title);
	const [formSubtitle, setFormSubtitle] = useState(subtitle);
  const [userEmailIsValid, setUserEmailIsValid] = useState(true);
  const [submitSuccessful, setSubmitSuccessful] =
    useState<boolean | undefined>(undefined);
  const [submitMessage, setSubmitMessage] = useState('');
  const [isSaving, setIsSaving] = useState(false);

	const validate = () => {
    //  validate fields
    if (!userEmail || !isEmail(userEmail)) {
      setUserEmailIsValid(false);
      return { isValid: false, message: 'Please enter your email address.' };
    }
    return { isValid: true, message: '' };
  };

  const submitJoinNow = (e) => {
    e.preventDefault();

    const { isValid, message } = validate();
    if (!isValid) {
      setSubmitSuccessful(false);
      setSubmitMessage(message);
      return;
    };

    setSubmitSuccessful(undefined);

    const subscriberDetails = {
      source: "website",
    };

    return Promise.all(
      [
        api.collectSubscriber(
          userEmail, 
          subscriberDetails
        ), 
      ])
      .then(() => {
        setFormTitle('Congratulations!');
				setFormSubtitle(`You are now part of the team. 
					<a href='/${process.env.MEMBER_CENTRE_SLUG}'>Click here</a> to update your preferences.`
				);
        setSubmitSuccessful(true);
      })
      .catch((e) => {
        setSubmitMessage(e.message);
        setSubmitSuccessful(false);
      })
      .finally(() => setIsSaving(false));
	}

  return (
		<div className={`MembershipChallenge ${styles.container} ${classes}`}>
			{submitSuccessful && (
				<Pixel email={userEmail} />
			)}
			<h3
				className={styles.title}
			>
				{formTitle}
			</h3>
			{formSubtitle && (
				<div 
					className={styles.subtitle}
					dangerouslySetInnerHTML={{
						__html: formSubtitle
					}} 
				/>
			)}
			<form 
				className={`needs-validation ${styles.form}
					${submitSuccessful ? ' d-none' : ''}`
				}
				noValidate
				onSubmit={submitJoinNow}
				autoComplete='off'				
			>
				<div className="form-row"
				>
					<div className="form-group col-md-9 m-0 d-flex align-items-center">
						<input
							className={clsx(`form-control`, { 'is-invalid': !userEmailIsValid })}
							id={`profile-field-email`}
							type="text"
							required
							value={userEmail}
							placeholder={'Enter your email address'}
							onChange={e => {
								const email = e.target.value;
								setUserEmail(email);
								setUserEmailIsValid(isEmail(email) && email != '');
							}}
						/>
					</div>
					<div className="form-group col-md-3 m-0">
						<Button
							type={"submit"}
							brand={brand}
							onClick={(e) => {
								submitJoinNow(e);
								onClick;
							}}
						>
							<Icon icon={'autorenew'} rotateIcon={isSaving} className={'mr-2'} />
							<span>{isSaving ? `Please wait...` : buttonLabel}</span>
						</Button>						
					</div>
				</div>
			</form>
	</div>
  );
};

export default styled(membershipChallengeStyles)(MembershipChallenge);